<template>
    <multiselect
        v-model="query"
        :options="async function(query) {
            return await fetchDeviceOptions(query)
        }"
        :allowEmpty="true"
        :canClear="true"
        :resolve-on-load="false"
        :delay="250"
        :searchable="true"
        :filter-results="false"
        :min-chars="0"
        :object="true"
        :clearOnSelect="true"
        value-prop="model"
        track-by="model"
        label="model"
        placeholder="Zoeken"
        @select="onSelect"
        class="custom-search-input"
    />
</template>

<script>
import Multiselect from '@vueform/multiselect'

export default {
    components: {
        Multiselect
    },

    props: {
        providerId: {
            type: Number,
            default: null,
        }
    },

    data() {
        return {
            query: null,
        }
    },

    methods: {
        async fetchDeviceOptions(query) {
            if (!query) {
                return [];
            }

            let options = [];

            await axios
                .get(`/api/subscription-offers/devices/search`, {
                    params: {
                        query: query,
                        provider_id: this.providerId ?? null
                    }
                })
                .then(({data}) => {
                    options = data
                })

            return options;
        },

        onSelect(option) {
            this.$emitter.$emit('search-select', option)
        },
    }
}
</script>
